import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterName',
    standalone: false
})
export class FilterNamePipe implements PipeTransform {

  transform(items: any[], filter: any): any {
    if (!items || !filter || !filter.value) {
        return items;
    }
    return items.filter(item => item[filter.key].toLowerCase().includes(filter.value));
}

}
